export default {
  tooltip: {
    balance: "موجودی کیف پول من",
    limitSwitch: "توضیح کوتاهی در مورد این بخش در این قسمت نمایش داده خواهد شد."
  },
  categoriesMenu: ["ارزان ترین", "گران ترین"],
  pricesTable: {
    title: "قیمت لحظه ای ارزهای دیجیتال",
    subtitle: "قیمت ارزها",
    noData: "رمز ارزی وجود ندارد",
    latestUpdate: {
      label: "آخرین بروز رسانی: ",
      time: "دقیقه پیش"
    },
    tableTabs: [
      {
        title: "علاقمندی ها",
        id: 3
      },
      {
        title: "دارایی ها",
        id: 2
      },
      {
        title: "همه ارزها",
        id: 1
      }
    ],
    tableHeader: [
      {
        text: "نماد",
        align: "start",
        sortable: true,
        value: "symbol",
        width: 100
      },
      {
        text: "قیمت",
        value: "sell_rate_price",
        align: "start",
        sortable: true
      },
      {
        text: "تغییرات",
        value: "daily_change_percent",
        align: "start",
        sortable: true
      }
    ],
    baseCurrencyPrice: "قیمت ({iso})",
    searchInputPlaceholder: "جستجو"
  },
  orderCard: {
    bitcoin: "بیتکوین"
  },
  orderForm: {
    amountInput: "مقدار",
    outcome: "جمع کل",
    income: "جمع کل",
    price: "قیمت",
    orderLimit: ["مبلغ", "درصد"],
    priceReached: "وقتی قیمت رسید به",
    tooltipDesc:
      "در این بخش شما می توانید تعیین کنید، وقتی قیمت رمز ارز مورد نظر شما به قیمت تعیین شده رسید، خرید یا فروش برای شما انجام شود.",
    orderValidityPeriod: "مدت اعتبار سفارش",
    minutes: "دقیقه",
    hours: "ساعت",
    wage: "کارمزد",
    received: "دریافتی",
    sell: "فروش",
    buy: "خرید",
    minAmountRules: "شما نمی‌توانید کمتر از {assetMin} {iso} وارد کنید",
    maxAmountRules: "شما نمی‌توانید بیشتر از {assetMax} {iso} وارد کنید",
    minPriceRules: "شما نمی‌توانید کمتر از {baseMin} {iso} وارد کنید",
    maxPriceRules: "شما نمی‌توانید بیشتر از {baseMax} {iso} وارد کنید",
    minOrderRules: "شما نمی‌توانید کمتر از {minMask} {iso} قیمت بگذارید",
    maxOrderRules: "شما نمی‌توانید بیشتر از {maxMask} {iso} قیمت بگذارید",
    minOrderPercentRules: "حداقل مقدار وارد شده -%{percent} می‌تواند باشد",
    maxZeroOrderPercentRules: "حداکثر مقدار وارد شده %0 می تواند باشد",
    minZeroOrderPercentRules: "حداقل مقدار وارد شده %0 می تواند باشد",
    maxOrderPercentRules: "حداکثر مقدار وارد شده %{percent} می‌تواند باشد",
    maxMinute: "دقیقه {maxMinute}",
    maxHour: "{maxHour} ساعت",
    and: "و",
    timeRules:
      "شما نمی‌توانید بیشتر از {minuteRule} {andRule} {hourRule} تعیین کنید",
    specifyOrderTime: "لطفا زمان اعتبار سفارش خود را تعیین کنید",
    orderTimeItems: [
      {
        value: "0",
        text: "کمتر از 1 ساعت"
      },
      {
        value: "3",
        text: "3 ساعت"
      },
      {
        value: "5",
        text: "5 ساعت"
      },
      {
        value: "8",
        text: "8 ساعت"
      }
    ]
  },
  tradingView: {
    title: "نمودار قیمت جهانی رمزارزها",
    description:
      "این نمودار براساس قیمت‌های اکسکوینو نیست و صرفا جهت مشاهده روند قیمت جهانی رمزارزها است.",
    filters: [
      {
        title: "ساعت",
        value: "hourly",
        tabIndex: 0
      },
      {
        title: "روزانه",
        value: "daily",
        tabIndex: 0
      },
      {
        title: "هفتگی",
        value: "weekly",
        tabIndex: 1
      },
      {
        title: "ماهانه",
        value: "monthly",
        tabIndex: 2
      }
    ]
  },
  orderList: {
    viewAllOrders: "مشاهده همه سفارشات",
    tabs: [
      {
        faTitle: "سفارشات کل",
        enTitle: ""
      },
      {
        faTitle: "سفارشات باز",
        enTitle: "PROCESSING"
      },
      {
        faTitle: "تکمیل شده",
        enTitle: "DONE"
      },
      {
        faTitle: "منقضی شده",
        enTitle: "EXPIRED"
      },
      {
        faTitle: "لغو شده",
        enTitle: "CANCELED"
      },
      {
        faTitle: "رد شده",
        enTitle: "FAILED"
      }
    ],
    dataTable: {
      typeOfOrder: {
        buy: "خرید",
        sell: "فروش"
      },
      cancelOrder: "لغو کردن",
      noData: "شما سفارش ثبت شده‌ای ندارید."
    },
    dataTableHeader: [
      {
        text: "کد سفارش",
        align: "right",
        sortable: false,
        value: "reference_number"
      },
      {
        text: "نوع",
        align: "center",
        sortable: false,
        value: "direction"
      },
      {
        text: "نام ارز",
        align: "center",
        sortable: false,
        value: "asset_currency_iso"
      },
      {
        text: "مقدار",
        align: "left",
        sortable: false,
        value: "asset_amount"
      },
      {
        text: "پایه",
        align: "center",
        sortable: false,
        value: "base_currency_iso"
      },
      {
        text: "قیمت",
        align: "left",
        sortable: false,
        value: "base_amount"
      },
      {
        text: "جمع کل",
        align: "left",
        sortable: false,
        value: "total_amount"
      },
      {
        text: "خالص دریافتی",
        align: "left",
        sortable: false,
        value: "pure_amount"
      },
      {
        text: "پایان اعتبار",
        align: "center",
        sortable: false,
        value: "expires_at",
        width: 150
      },
      {
        text: "وضعیت",
        align: "right",
        sortable: false,
        value: "status_locale",
        width: 150
      },
      {
        text: "زمان ثبت",
        align: "center",
        sortable: false,
        value: "date",
        width: 150
      },
      {
        text: "عملیات",
        align: "center",
        sortable: false,
        value: "actions",
        width: 100
      }
    ],
    dataTableHeaderWithoutOperation: [
      {
        text: "کد سفارش",
        align: "right",
        sortable: false,
        value: "reference_number"
      },
      {
        text: "نوع",
        align: "center",
        sortable: false,
        value: "direction"
      },
      {
        text: "نام ارز",
        align: "center",
        sortable: false,
        value: "asset_currency_iso"
      },
      {
        text: "مقدار",
        align: "left",
        sortable: false,
        value: "asset_amount"
      },
      {
        text: "پایه",
        align: "center",
        sortable: false,
        value: "base_currency_iso"
      },
      {
        text: "قیمت",
        align: "left",
        sortable: false,
        value: "base_amount"
      },
      {
        text: "جمع کل",
        align: "left",
        sortable: false,
        value: "total_amount"
      },
      {
        text: "خالص دریافتی",
        align: "left",
        sortable: false,
        value: "pure_amount"
      },
      {
        text: "پایان اعتبار",
        align: "center",
        sortable: false,
        value: "expires_at",
        width: 150
      },
      {
        text: "وضعیت",
        align: "right",
        sortable: false,
        value: "status_locale",
        width: 150
      },
      {
        text: "زمان ثبت",
        align: "center",
        sortable: false,
        value: "date",
        width: 150
      }
    ],
    modal: {
      ordersHistory: "تاریخچه سفارشات"
    }
  },
  orderInvoiceCard: {
    title: "تایید سفارش",
    currencyType: "نوع ارز",
    currencyBase: "پایه",
    currencyAmount: "مقدار",
    currencyPrice: "قیمت",
    currencyTotalAmount: "جمع کل",
    orderExpiredTime: {
      title: "مدت اعتبار سفارش",
      hour: "ساعت",
      minute: "دقیقه"
    },
    currencyFee: "کارمزد",
    currencyPureAmount: "خالص دریافتی",
    buyOrder: "تایید سفارش و خرید",
    sellOrder: "تایید سفارش و فروش"
  },
  orderNotificationCard: {
    title: "موجودی ناکافی",
    description:
      "موجودی کیف پول شما کافی نیست. لطفا موجودی خود را افزایش داده و مجدد سفارش‌گذاری کنید.",
    cancelBtn: "انصراف",
    confirmBtn: "افزایش موجودی"
  },
  exchangeAutoComplete: {
    inputPlaceholder: "جستجو بر اساس نام ارز و نام اختصاصی...",
    noResults: "نتیجه‌ای یافت نشد.",
    noData: "نتیجه‌ای یافت نشد."
  },
  numberInput: {
    allAssetsButton: "همه"
  }
};
